import hoverintent from 'hoverintent';

export default class Menu {
  constructor(theme, element) {
    this.theme = theme;
    this.element = element;
    this.activeClass = 'nav-hover';
    this.sectionId = this.element.getAttribute('data-wetheme-section-id');
    this.megaMenuDropdowns = document.querySelectorAll('.site-nav__dropdown.mega-menu-dropdown');
    this.megaMenu = document.querySelector('.mega-menu-block');
    this.megaMenuChildren = document.querySelectorAll('.mega-menu-block .dropdown-submenu');
    this.resizeTimeout = null;
    this.hideTimeout = null;

    this.nav = document.getElementById('AccessibleNav');
    this.allLinks = this.nav.querySelectorAll('a');
    this.topLevel = this.nav.querySelectorAll('li > a');
    this.parents = this.nav.querySelectorAll('.site-nav--has-dropdown');
    this.mainLinks = this.nav.querySelectorAll('.site-nav--has-dropdown.first-level-dropdown');
    this.subMenus = this.nav.querySelectorAll('.site-nav__dropdown');
    this.subMenuLinks = this.nav.querySelectorAll('.site-nav__dropdown a');
    this.overlayHeader = document.querySelector('header.overlay-header');

    this.parents.forEach((el) => {
      this.setDropdownOffset(el);
    });

    this.subMenus.forEach((el) => {
      this.initScrollHandler(el);
      if (el.classList.contains('mega-menu-dropdown')) {
        // Delay the hide of the mega menu dropdown
        el.addEventListener('mouseleave', () => this.scheduleHideDropdown(el));
        el.addEventListener('focusout', () => this.scheduleHideDropdown(el));
      } else {
        // Close the dropdown immediately
        el.addEventListener('mouseleave', () => this.hideDropdown(el));
        el.addEventListener('focusout', () => this.hideDropdown(el));
      }

      // Add mouseover event to handle child dropdowns
      el.querySelectorAll('li').forEach((childEl) => {
        childEl.addEventListener('mouseover', (evt) => this.handleChildHover(evt, childEl));
      });
    });

    this.adjustMegaMenuPosition();

    window.addEventListener('resize', () => {
      if (this.resizeTimeout) {
        clearTimeout(this.resizeTimeout);
      }

      this.resizeTimeout = setTimeout(() => {
        this.parents.forEach((el) => {
          this.setDropdownOffset(el);
          this.adjustMegaMenuPosition();
        });
      }, 300);
    });

    if (window.Shopify.designMode) {
      document.addEventListener('shopify:section:select', (e) => {
        if (e.detail.sectionId === this.sectionId) {
          this.element.classList.add('section-selected');
        } else {
          this.element.classList.remove('section-selected');
        }
      });

      document.addEventListener('shopify:section:deselect', (e) => {
        if (e.detail.sectionId === this.sectionId) {
          this.element.classList.remove('section-selected');
        }
      });

      document.addEventListener('shopify:section:load', (e) => {
        if (e.detail.sectionId === this.sectionId) {
          this.adjustMegaMenuPosition();
        }
      });
    }

    this.parents.forEach((el) => {
      el.addEventListener('mouseover', (evt) => this.handleParentEvent(evt, el));
      el.addEventListener('touchstart', (evt) => this.handleParentEvent(evt, el));
      el.addEventListener('focusin', (evt) => this.handleParentEvent(evt, el));
    });

    this.parents.forEach((el) => {
      hoverintent(
        el,
        (evt) => {
          document.querySelectorAll(`.${this.activeClass}`).forEach((activeEl) => {
            if (!activeEl.contains(evt.target)) {
              activeEl.classList.remove(this.activeClass);
            }
          });
        },
        () => {
          // Avoid using hideDropdown() here.
        }
      );
    });

    this.mainLinks.forEach((el) => {
      if (el.classList.contains('mega-menu')) {
        // Delay the hide of the mega menu dropdown
        el.addEventListener('mouseleave', () => this.scheduleHideDropdown(el));
      } else {
        // Close the dropdown immediately
        el.addEventListener('mouseleave', () => this.hideDropdown(el));
      }
    });

    document.querySelector('.site-header').addEventListener('mouseleave', () => {
      // Replace direct hideDropdown calls with scheduleHideDropdown
      this.scheduleHideDropdown();
    });

    this.subMenus.forEach((el) => {
      if (el.classList.contains('mega-menu-dropdown')) {
        // Delay the hide of the mega menu dropdown
        el.addEventListener('mouseleave', () => this.scheduleHideDropdown(el));
        el.addEventListener('focusout', () => this.scheduleHideDropdown(el));
      } else {
        // Close the dropdown immediately
        el.addEventListener('mouseleave', () => this.hideDropdown(el));
        el.addEventListener('focusout', () => this.hideDropdown(el));
      }
    });

    if (this.megaMenu) {
      // Replace direct hideDropdown calls with scheduleHideDropdown
      this.megaMenu.addEventListener('mouseleave', () => this.scheduleHideDropdown());
    }

    this.subMenuLinks.forEach((link) => {
      link.addEventListener('touchstart', (evt) => {
        evt.stopImmediatePropagation();
      });
    });

    this.allLinks.forEach((link) => {
      link.addEventListener('focusin', (evt) => {
        this.closeSiblings(link.parentElement, evt);
      });
    });

    document.querySelectorAll('.site-header a, .site-header button, .site-header select').forEach((el) => {
      el.addEventListener('focusin', () => {
        let closeAllMenus = true;
        this.allLinks.forEach((link) => {
          if (link === el) {
            closeAllMenus = false;
          }
        });

        if (closeAllMenus) {
          this.parents.forEach((parent) => {
            this.hideDropdown(parent);
          });
        }
      });
    });

    // Bind the event handler
    this.handleBodyTouchStart = this.handleBodyTouchStart.bind(this);
  }

  // Named event handler for touchstart
  handleBodyTouchStart(evt) {
    if (!evt.target.closest('.site-nav__link, .dropdown-submenu')) {
      this.hideDropdown();
    }
  }

  handleChildHover(evt, childEl) {
    // Close all sibling dropdowns
    this.hideDropdown(Array.from(childEl.parentElement.children).filter(sibling => sibling !== childEl));

    // Show the current dropdown if it has one
    if (childEl.classList.contains('site-nav--has-dropdown')) {
      this.showDropdown(childEl);
    }
  }

  handleParentEvent(evt, el) {
    let ret = true;
    if (!el.classList.contains(this.activeClass)) {
      evt.preventDefault();
      this.hideDropdown(Array.from(el.parentElement.children).filter(sibling => sibling !== el));
      ret = false;
    }
    this.showDropdown(el);
    return ret;
  }

  showDropdown(el) {
    // Clear any existing hide timeout to prevent accidental hiding
    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout);
      this.hideTimeout = null;
    }

    if (!el) return;
    el.classList.add(this.activeClass);

    document.querySelector('.sticky-header')?.classList.remove('sticky-header-transformed');

    if (el.classList.contains('mega-menu')) {
      // Add force-hover class to the overlay header when the mega menu dropdown is hovered
      if (this.overlayHeader) {
        this.overlayHeader.classList.add('force-hover');
      }
    } else {
      // Remove force-hover class from the overlay header if it exists
      if (this.overlayHeader && this.overlayHeader.classList.contains('force-hover')) {
        this.overlayHeader.classList.remove('force-hover');
      }
    }

    setTimeout(() => {
      document.body.addEventListener('touchstart', this.handleBodyTouchStart);
    }, 250);
  }

  /**
   * Schedule hiding the dropdown with a delay.
   * @param {HTMLElement} el - The dropdown element to hide.
  */
  scheduleHideDropdown(el) {
    // Clear any existing hide timeout
    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout);
    }

    // Set a new timeout to hide the dropdown after 300ms
    this.hideTimeout = setTimeout(() => {
      // Remove force-hover class from the overlay header when the mega menu dropdown is hidden
      if (this.overlayHeader) {
        this.overlayHeader.classList.remove('force-hover');
      }

      this.hideDropdown(el);
      this.hideTimeout = null;
    }, 500); // Delay in milliseconds
  }

  hideDropdown(elements) {
    // Clear any existing hide timeout to avoid multiple executions
    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout);
      this.hideTimeout = null;
    }

    if (elements) {
      // Ensure elements is an array or NodeList
      if (!Array.isArray(elements) && !(elements instanceof NodeList)) {
        elements = [elements]; // Convert single element to array
      }
  
      elements.forEach(el => {
        el.classList.remove(this.activeClass);
      });
    } else {
      document.querySelectorAll('.site-nav--has-dropdown').forEach((dropdown) => {
        dropdown.classList.remove(this.activeClass);
      });
    }
  
    document.body.removeEventListener('touchstart', this.handleBodyTouchStart);
  
    if (!document.querySelector('.nav-hover')) {
      const stickyHeader = document.querySelector('.sticky-header');
      if (stickyHeader) {
        stickyHeader.classList.add('sticky-header-transformed');
      }
    }
  }

  adjustMegaMenuPosition() {
    this.megaMenuDropdowns.forEach((item) => {
      const menuItemLeft = item.closest('.site-nav--has-dropdown').getBoundingClientRect().left;
      item.style.left = `-${menuItemLeft}px`;
    });

    // Need the scrollbar width in order to set the menu width to 100vw
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    this.element.style.setProperty('--scrollbar-width', `${scrollbarWidth}px`);
  }

  setDropdownOffset(el) {
    const dropdown = el.querySelector('.site-nav__dropdown.standard-dropdown');
    if (!dropdown) return;

    const navPosition = dropdown.getAttribute('data-logo-placement');
    const dropdownRight = window.innerWidth - (dropdown.getBoundingClientRect().left + dropdown.offsetWidth);

    if (dropdownRight < 15) {
      dropdown.style.right = '0';
      dropdown.style.left = 'auto';
    }

    // Get all subdropdown elements and apply the same logic to each one.
    const subDropdowns = dropdown.querySelectorAll('.site-nav__subdropdown');
    subDropdowns.forEach(subDropdown => {
      const subDropdownRight = window.innerWidth - (subDropdown.getBoundingClientRect().left + subDropdown.offsetWidth);
      if (subDropdownRight < 15) {
        if (navPosition === 'left' || navPosition === 'above') {
          subDropdown.style.left = 'auto';
          subDropdown.style.right = '100%';
        } else {
          subDropdown.style.left = '100%';
          subDropdown.style.right = 'auto';
        }
      }
    });
  }

  initScrollHandler(el) {
    let scrolling;
    el.addEventListener('scroll', () => {
      clearTimeout(scrolling);
      el.classList.add('scrolling');
      scrolling = setTimeout(() => {
        el.classList.remove('scrolling');
      }, 800);
    });
  }

  closeSiblings(el, evt) {
    if (!el.classList.contains(this.activeClass)) {
      evt.preventDefault();
      this.hideDropdown(Array.from(el.parentElement.children).filter(sibling => sibling !== el));
    }
  }
}
